/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
export var WorkflowTransitionType;
(function (WorkflowTransitionType) {
    WorkflowTransitionType[WorkflowTransitionType["Creator"] = 0] = "Creator";
    WorkflowTransitionType[WorkflowTransitionType["Approvers"] = 1] = "Approvers";
    WorkflowTransitionType[WorkflowTransitionType["CC"] = 2] = "CC";
})(WorkflowTransitionType || (WorkflowTransitionType = {}));
